document.addEventListener('DOMContentLoaded', function () {
  /* ---- mobile nav toggle ---- */
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---- quantity steppers ---- */
  document.querySelectorAll('[data-quantity-input]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-quantity-minus]');
    var plus = wrap.querySelector('[data-quantity-plus]');
    if (!input) return;
    // The input's own min decides the floor: 1 on product pages, 0 in the cart (where 0 removes the line).
    var floor = input.min !== '' ? parseInt(input.min, 10) || 0 : 1;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(floor, parseInt(input.value || '1', 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---- product gallery: thumbnails, dots and swipe ---- */
  var gallery = document.querySelector('[data-product-gallery]');
  var galleryGoToMedia = function () {}; // no-op fallback if there's no gallery

  if (gallery) {
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb-id]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot-id]'));
    var mediaIds = thumbs.map(function (t) { return t.getAttribute('data-thumb-id'); });

    galleryGoToMedia = function (id) {
      var thumb = thumbs.filter(function (t) { return t.getAttribute('data-thumb-id') === id; })[0];
      if (!thumb) return;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var dot = dots.filter(function (d) { return d.getAttribute('data-dot-id') === id; })[0];
      if (dot) dot.classList.add('is-active');
      var full = thumb.getAttribute('data-full-src');
      if (mainImg && full) mainImg.src = full;
    };

    function goToIndex(index) {
      if (!mediaIds.length) return;
      var i = ((index % mediaIds.length) + mediaIds.length) % mediaIds.length;
      galleryGoToMedia(mediaIds[i]);
    }

    function currentIndex() {
      var activeThumb = thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      return activeThumb ? mediaIds.indexOf(activeThumb.getAttribute('data-thumb-id')) : 0;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { galleryGoToMedia(thumb.getAttribute('data-thumb-id')); });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { galleryGoToMedia(dot.getAttribute('data-dot-id')); });
    });

    if (mainWrap && mediaIds.length > 1) {
      var touchStartX = null;
      mainWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) {
          goToIndex(currentIndex() + (deltaX < 0 ? 1 : -1));
        }
        touchStartX = null;
      }, { passive: true });
    }
  }

  /* ---- product variant picker ---- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsJson = productForm.querySelector('[data-product-variants]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var selects = Array.prototype.slice.call(productForm.querySelectorAll('[data-option-select]'));
    var idInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-product-compare-price]');
    var availabilityEl = document.querySelector('[data-product-availability]');
    var submitBtn = productForm.querySelector('[data-add-to-cart]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function findVariant() {
      var selected = selects.map(function (s) { return s.value; });
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    // Lots: the "Dans votre lot" line of the description follows the chosen lengths,
    // read from the variant name ("2 × 18 + 2 × 20 pouces (46 et 51 cm)").
    function syncLotDetail(variant) {
      var el = document.querySelector('.lot-detail');
      var m = el && variant && /2 × (\d+) \+ 2 × (\d+) pouces \((\d+) et (\d+) cm\)/.exec(variant.title);
      if (m) el.textContent = '2 paquets de ' + m[1] + ' pouces (' + m[3] + ' cm) et 2 paquets de ' + m[2] + ' pouces (' + m[4] + ' cm)';
    }

    function updateForVariant() {
      var variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-label-unavailable') || 'Indisponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      // Lots: the "-10 % inclus" box shows the cart price of the chosen length (Shopify rounds the discount down).
      var lotCart = document.querySelector('[data-lot-cart-price]'), lotList = document.querySelector('[data-lot-list-price]');
      if (lotCart) lotCart.textContent = formatMoney(variant.price - Math.floor(variant.price / 10));
      if (lotList) lotList.textContent = formatMoney(variant.price);
      syncLotDetail(variant);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (availabilityEl) {
        if (variant.available) {
          availabilityEl.textContent = availabilityEl.getAttribute('data-label-in') || 'En stock';
          availabilityEl.className = 'product-info__availability product-info__availability--in';
        } else {
          availabilityEl.textContent = availabilityEl.getAttribute('data-label-out') || 'Épuisé';
          availabilityEl.className = 'product-info__availability product-info__availability--out';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? (submitBtn.getAttribute('data-label-add') || 'Ajouter au panier')
          : (submitBtn.getAttribute('data-label-unavailable') || 'Épuisé');
      }
      // Thumbnails are keyed by media id; featured_image.id is a different (image) id and never matched.
      if (variant.featured_media) {
        galleryGoToMedia(String(variant.featured_media.id));
      }
      if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + variant.id);
    }

    selects.forEach(function (s) { s.addEventListener('change', updateForVariant); });
    // A link may open the lot on any length (?variant=), while the description is written for the first one.
    syncLotDetail(findVariant());
  }
});


document.addEventListener('DOMContentLoaded', function () {
  /* ---- header elevation on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- scroll reveal ---- */
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('reveal-on');

  var groups = [
    { sel: '.shell-section__head', step: 0 },
    { sel: '.trust-bar__item', step: 70 },
    { sel: '.cat-tile', step: 80 },
    { sel: '.product-card', step: 70 },
    { sel: '.texture-card', step: 70 },
    { sel: '.rich-text', step: 0 },
    { sel: '.newsletter', step: 0 },
    { sel: '.hero__brand-img', step: 0 },
    { sel: '.hero__brand-cta', step: 0 },
    { sel: '.product-gallery', step: 0 },
    { sel: '.product-info', step: 0 }
  ];

  groups.forEach(function (group) {
    document.querySelectorAll(group.sel).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      if (group.step && el.parentNode) {
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.setProperty('--reveal-delay', Math.min(i * group.step, 420) + 'ms');
      }
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

  document.querySelectorAll('[data-reveal]').forEach(function (el) { observer.observe(el); });

  /* Safety net: nothing already on screen may stay invisible if the observer misfires. */
  setTimeout(function () {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-revealed');
    });
  }, 2500);
});

/* ---- product cards: hovering a colour dot previews that colour's photo ---- */
// The card image has a srcset, which wins over src: clear it while previewing and put it back after.
document.addEventListener('mouseover', function (e) {
  var dot = e.target.closest && e.target.closest('.card-swatch');
  if (!dot) return;
  var card = dot.closest('.product-card'), img = card && card.querySelector('.product-card__media img');
  if (!img || !dot.dataset.swatchSrc) return;
  if (!img.dataset.originalSrc) { img.dataset.originalSrc = img.src; img.dataset.originalSrcset = img.getAttribute('srcset') || ''; }
  img.removeAttribute('srcset');
  img.src = dot.dataset.swatchSrc;
  card.classList.add('is-swatching');
});
document.addEventListener('mouseout', function (e) {
  var list = e.target.closest && e.target.closest('.card-swatches');
  if (!list || list.contains(e.relatedTarget)) return;
  var card = list.closest('.product-card'), img = card && card.querySelector('.product-card__media img');
  if (img && img.dataset.originalSrc) {
    if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
    img.src = img.dataset.originalSrc;
  }
  if (card) card.classList.remove('is-swatching');
});

/* ---- cart: save every quantity change right away and refresh prices, without reloading the page ---- */
document.addEventListener('DOMContentLoaded', function () {
  var cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm || !window.fetch) return;

  var section = cartForm.closest('[data-cart-section]');
  var sectionId = cartForm.getAttribute('data-section-id');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var errorBox = cartForm.querySelector('[data-cart-error]');
  var updateButton = cartForm.querySelector('[data-cart-update]');
  // .button sets display, which would override the hidden attribute.
  if (updateButton) updateButton.style.display = 'none';

  // A page restored from the back/forward cache would show stale quantities.
  window.addEventListener('pageshow', function (e) { if (e.persisted) location.reload(); });

  var queue = Promise.resolve();
  var timers = {};

  function showError(message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function lineOf(key) { return cartForm.querySelector('[data-line-key="' + key + '"]'); }

  // A removed line folds away (height to 0) instead of the page jumping; it leaves the DOM once folded.
  function collapse(line) {
    if (!line || line.classList.contains('is-removing')) return;
    line.style.height = line.offsetHeight + 'px';
    line.getBoundingClientRect();
    line.classList.add('is-removing');
    line.style.height = '0px';
  }
  function uncollapse(line) {
    if (!line) return;
    line.classList.remove('is-removing');
    line.style.height = '';
  }
  function drop(line) {
    if (!line) return;
    var gone = false;
    function done() { if (!gone) { gone = true; line.remove(); } }
    line.addEventListener('transitionend', function (e) { if (e.propertyName === 'height') done(); });
    setTimeout(done, 450);
  }

  function setCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
  }

  function applySection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // Last line gone: show the fresh "empty cart" state in place.
    if (!doc.querySelector('[data-cart-form]')) {
      var fresh = doc.querySelector('[data-cart-section]');
      if (section && fresh) {
        section.innerHTML = fresh.innerHTML;
        section.classList.add('is-swapping');
      }
      setCount(0);
      return;
    }
    var itemCount = 0;
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      var key = input.getAttribute('data-key');
      var freshInput = doc.querySelector('input[data-key="' + key + '"]');
      // Gone from the cart (e.g. emptied by another tab): fold it away too.
      if (!freshInput) { var line = lineOf(key); collapse(line); drop(line); return; }
      // Don't overwrite a value the shopper changed again while this request was in flight.
      if (!timers[key]) input.value = freshInput.value;
      itemCount += parseInt(input.value, 10) || 0;
    });
    cartForm.querySelectorAll('[data-line-price]').forEach(function (el) {
      var fresh = doc.querySelector('[data-line-price="' + el.getAttribute('data-line-price') + '"]');
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
    // Discount lines, the price breakdown and the bundle tips change with the quantities too.
    cartForm.querySelectorAll('[data-cart-refresh]').forEach(function (el) {
      var fresh = doc.querySelector('[data-cart-refresh="' + el.getAttribute('data-cart-refresh') + '"]');
      el.innerHTML = fresh ? fresh.innerHTML : '';
    });
    var subtotal = cartForm.querySelector('[data-cart-subtotal]');
    var freshSubtotal = doc.querySelector('[data-cart-subtotal]');
    if (subtotal && freshSubtotal) subtotal.textContent = freshSubtotal.textContent;
    // Update the free-shipping bar in place so its fill slides instead of jumping.
    var ship = cartForm.querySelector('[data-free-shipping]');
    var freshShip = doc.querySelector('[data-free-shipping]');
    if (ship && freshShip) {
      var shipText = ship.querySelector('.free-ship__text');
      var freshShipText = freshShip.querySelector('.free-ship__text');
      if (shipText && freshShipText) { shipText.className = freshShipText.className; shipText.innerHTML = freshShipText.innerHTML; }
      var shipFill = ship.querySelector('.free-ship__fill');
      var freshShipFill = freshShip.querySelector('.free-ship__fill');
      if (shipFill && freshShipFill) shipFill.style.width = freshShipFill.style.width;
    }
    setCount(itemCount);
  }

  // On a rejected change Shopify may still have adjusted the line (e.g. capped to stock), so re-read everything.
  // No JSON Accept header here: on /cart it makes Shopify return the raw cart instead of the rendered section.
  function resync() {
    return fetch(location.pathname + '?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (sections) { if (sections[sectionId]) applySection(sections[sectionId]); });
  }

  function sendChange(input) {
    var key = input.getAttribute('data-key');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    var line = lineOf(key);
    // Lines are addressed by key, so removing one never shifts the others.
    if (quantity === 0) collapse(line);
    queue = queue.then(function () {
      cartForm.classList.add('is-updating');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId], sections_url: location.pathname })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            uncollapse(line);
            showError(data.description || data.message || 'Impossible de mettre à jour cette quantité.');
            return resync();
          }
          showError('');
          if (quantity === 0) drop(line);
          if (data.sections && data.sections[sectionId]) applySection(data.sections[sectionId]);
        });
      }).catch(function () {
        uncollapse(line);
        if (quantity === 0) input.value = 1;
        showError('Connexion perdue : la quantité n\'a pas pu être enregistrée.');
      }).then(function () {
        cartForm.classList.remove('is-updating');
      });
    });
  }

  cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-key');
      clearTimeout(timers[key]);
      // Going down to 0 removes the line: do it at once rather than after the typing pause.
      if ((parseInt(input.value, 10) || 0) === 0) { delete timers[key]; sendChange(input); return; }
      timers[key] = setTimeout(function () { delete timers[key]; sendChange(input); }, 350);
    });
  });

  // "Retirer" does the same as stepping down to 0, in place; its link still works without JavaScript.
  cartForm.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cart-remove]');
    if (!link) return;
    var input = link.closest('[data-line-key]').querySelector('input[name="updates[]"]');
    if (!input) return;
    e.preventDefault();
    input.value = 0;
    input.dispatchEvent(new Event('change'));
  });
});
